import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginModel } from '../model/FormsEntity/loginForm';
import { AuthenticationService } from '../service/authentication.service';
import { AppComponent } from '../app/app.component';
import { NotificationService } from '../core/core.module';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  login: LoginModel = new LoginModel();
  invalidLogin = false;

  constructor(private fb: FormBuilder,
    private loginservice: AuthenticationService,
    private router: Router, private notificationService:NotificationService,
    private reloadPage: AppComponent) { }
  loginForm = this.fb.group({
    userName: [null, Validators.compose(
      [Validators.required, Validators.pattern('^[0-9]{10}$')])],
    password: [null, Validators.required],
  });

  ngOnInit() {
    let user = sessionStorage.getItem('currentUser');
    if (user != null) {
      this.router.navigate(['/home'])
    } else {

    }
  }
  onSubmit(): void {
    if (this.loginForm.invalid) {
      return;
    }
    sessionStorage.setItem('mobileNo', this.login.mobileNumber);
    sessionStorage.setItem('passkey', this.login.userPassword);
    const param = {
      'mobileNumber':this.login.mobileNumber,
      'userPassword':this.login.userPassword,
      'deptId':null,
      'roleId':null
    }
    this.loginservice.authenticate(param).subscribe(
      data => {
        this.invalidLogin = false;
        // console.log(data);

        // this.reloadPage.reload();
      },
      error => {
        this.invalidLogin = true;

      }
    );
  }
}
